import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";

export function DataDemoBadge({ status }) {
  if (status === "demo") {
    return (
      <Badge data-testid="data-demo-badge" className="bg-amber-100 text-amber-800 hover:bg-amber-100 border-0 font-semibold">
        DATA DEMO
      </Badge>
    );
  }
  return null;
}

export function CompletenessBar({ value }) {
  const v = value ?? 0;
  const color = v >= 80 ? "#10B981" : v >= 50 ? "#F59E0B" : "#EF4444";
  return (
    <div className="w-full" data-testid="completeness-bar">
      <div className="flex justify-between text-xs text-muted-foreground mb-1">
        <span>Kelengkapan data</span>
        <span style={{ color }}>{v}%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full rounded-full transition-all duration-1000" style={{ width: `${v}%`, backgroundColor: color }} />
      </div>
    </div>
  );
}
